import Dialog from "dialog";
import template from "../html/dialog-config-steering.html";
import css from "../css/dialog-config-steering.css";

class ConfigSteeringDialog extends Dialog {
	static get template() {
		return template;
	}
	static get css() {
		return css;
	}
	static constructor() {
		customElements.define("fulljs-dialog-config-steering", ConfigSteeringDialog);
	}
	constructor() {
		super();

		this.show();
	}
	connectedCallback() {
		super.connectedCallback();

		this.onupdatedevices_handler_f = this.onupdatedevices_handler.bind(this);
		document.addEventListener("onupdatedevices", this.onupdatedevices_handler_f);

		this.onupdatedevices_handler({detail: application.devices});
		this.spinnerTargetRPM.value = this.textboxCurrentRPM.value;
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		document.removeEventListener("onupdatedevices", this.onupdatedevices_handler_f);
	}
	buttonClose_click(event) {
		this.close();
	}
	onupdatedevices_handler(event) {
		var devices = event.detail;

		this.labelDeviceID.value = devices.stirring.id;
		this.labelDeviceStatus.value = devices.stirring.status;
		this.textboxCurrentRPM.value = devices.stirring.rpm;
        }
	spinnerTargetRPM_change(event) {
		server.rcall("RM_steering_setRPM", this.spinnerTargetRPM.value).catch(function(result) {
			alert(result);
		});
	}
}

ConfigSteeringDialog.constructor();

export default ConfigSteeringDialog;